// extracted by mini-css-extract-plugin
module.exports = {"style":"styles_style__1TcGF","container":"styles_container__2aeq3","image":"styles_image__RLsyH"};